import React, { FC, useEffect, useState } from 'react';
import { Button, InputText } from '@agro1desenvolvimento/react-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { RouteComponentProps, useParams } from 'react-router-dom';
import ResetPasswordService from '../../services/reset-password';
import notificationsService from '../../services/notifications';
import { ChangePasswordRouteParams } from '../../@types/route-params';
import AuthCard from '../../components/AuthCard';
import PasswordInput from '../../components/PasswordInput';

type PropTypes = RouteComponentProps;

const ChangePasswordPage: FC<PropTypes> = ({ history }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmationPassword, setConfirmationPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const { id, token, app } = useParams<ChangePasswordRouteParams>();

  const footer = (
    <>
      <div className="p-text-center auth-footer">
        <Button
          label="Salvar"
          className="auth-button"
          type="submit"
          form="reset-password-form"
          disabled={loading}
        />

        <div className="p-text-center p-my-5">
          { loading && <FontAwesomeIcon icon="spinner" spin /> }
        </div>
      </div>
    </>
  );

  useEffect(() => { getUser(); }, []);

  const getUser = async () => {
    try {
      setLoading(true);
      const user = await ResetPasswordService.getUser(id, token);

      setEmail(user.email);
    } catch (error) {
      const message = error?.response?.data?.message
          || 'Erro ao recuperar senha.';

      notificationsService.error({ message });
      history.push('/login');
    } finally {
      setLoading(false);
    }
  };

  const handleResetPassword = async (event: React.FormEvent<HTMLFormElement>) => {
    if (password !== confirmationPassword) {
      notificationsService.error({ message: 'As senhas não são iguais.' });
      return;
    }

    event.preventDefault();
    try {
      setLoading(true);
      await ResetPasswordService.changePassword(id, token, password);
      if (app) {
        history.push('/reset_password/confirmation');
      } else {
        history.push('/login');
      }
      notificationsService.success({ message: 'Senha alterada com sucesso.' });
    } catch (error) {
      const message = error?.response?.data?.message
          || 'Não foi possível alterar sua senha.';

      notificationsService.error({ message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthCard title="Recuperação de senha" footer={footer}>
      <form onSubmit={handleResetPassword} id="reset-password-form">
        <div className="p-col-12 auth-field">
          <label htmlFor="email" className="auth-label">
            Email
          </label>
          <div className="auth-input-container">
            <FontAwesomeIcon
              icon="user"
              className="auth-icon"
            />
            <InputText
              id="email"
              disabled
              value={email}
              title="Email"
              className="auth-input"
            />
          </div>
        </div>

        <PasswordInput
          id="password"
          label="Nova Senha"
          value={password}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPassword(e.target.value)}
          placeholder="Digite sua nova senha"
          title="Nova Senha"
          required
          autoFocus
        />

        <PasswordInput
          id="confirmationPassword"
          label="Confirmar Senha"
          value={confirmationPassword}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            setConfirmationPassword(e.target.value);
          }}
          placeholder="Confirme sua nova senha"
          title="Confirmar Senha"
          required
        />
      </form>
    </AuthCard>
  );
};

export default ChangePasswordPage;
